<template>
  <div>
    <div class="logo-container">
      <img v-if="isCollapse" :src="miniLogo" />
      <img v-else :src="wideLogo" />
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :collapse="isCollapse"
        :unique-opened="false"
        :collapse-transition="false"
        mode="vertical"
      >
        <SidebarItem
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
          :is-collapse="isCollapse"
        />
        <div class="divider mt-1" />
        <MessengerSubscription :mini="isCollapse" class="mt-1" />
        <AddNote v-if="isStaff" :mini="isCollapse" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { useAppStore } from '@/store/modules/app'
import SidebarItem from './SidebarItem.vue'
import { useLogo } from '@/hooks/useLogo'
import MessengerSubscription from '@/layout/components/MessengerSubscription.vue'
import AddNote from '@/layout/components/Sidebar/AddNote.vue'
import { useUserStore } from '@/store/modules/user'

export default defineComponent({
  name: 'SideBar',
  components: {
    AddNote,
    SidebarItem,
    MessengerSubscription
  },
  setup() {
    const appStore = useAppStore()
    const userStore = useUserStore()

    const { isStaff } = userStore
    const { miniLogo, wideLogo } = useLogo()
    const routes = computed(() => {
      return appStore.routes
    })
    const isCollapse = computed(() => {
      return !appStore.sidebar.opened
    })

    return { routes, isCollapse, miniLogo, wideLogo, isStaff }
  }
})
</script>

<style lang="scss">
.sidebar-container {
  // reset element-ui css
  .horizontal-collapse-transition {
    transition:
      0s width ease-in-out,
      0s padding-left ease-in-out,
      0s padding-right ease-in-out;
  }

  .scrollbar-wrapper {
    overflow-x: hidden !important;
  }

  .el-scrollbar__view {
    height: 100%;
  }

  .el-scrollbar__bar {
    &.is-vertical {
      right: 0px;
    }
    &.is-horizontal {
      display: none;
    }
  }
}
</style>

<style lang="scss" scoped>
.el-scrollbar {
  height: 100%;
}
:deep(.el-menu) {
  border: none;
  height: 100%;
  padding-top: 15px;
  width: 100% !important;
  background-color: var(--menu-bg-color);
}

:deep(.el-menu.el-menu--inline) {
  padding-top: 0px;
}

:deep(.el-menu-item) {
  color: var(--menu-text-color);
}

:deep(.el-menu-item.is-active) {
  color: var(--menu-text-active-color);
}

:deep(.el-sub-menu__title) {
  color: var(--menu-text-color);
}

:deep(.el-menu-item:hover),
:deep(.el-menu-item:focus),
:deep(.el-sub-menu__title:hover) {
  background-color: var(--menu-bg-hover-color);
}

.logo-container {
  background: var(--menu-bg-color);
  text-align: center;
  img {
    max-width: 100%;
    margin-top: 15px;
    padding: 0 5px;
  }
}
.divider {
  height: 1px;
  width: 90%;
  margin: 0 auto;
  background-color: var(--menu-text-active-color);
}
</style>
